import { useState } from 'react'

import { useNotification } from '../../../../../hooks'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../Icon'
import { togglePipelinePhaseVisibilityToTenant } from '../../../../Pipeline'
import { getVisibilityIcon } from '../../../../Table'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_VISIBILITY } from '../../RequestProfileTabActivities.constants'
import { getActivityVisibilityChangeNotificationKey } from '../../RequestProfileTabActivities.utils'
import { RequestProfileTabActivitiesPhaseHeaderMetaItem } from '../RequestProfileTabActivitiesPhaseHeaderMetaItem'

function RequestProfileTabActivitiesPhaseHeaderVisibility({
  canEdit,
  phase,
  onReloadPhase,
}) {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleReloadOpenActivities } = useRequestProfileContext()

  const [isLoading, setLoading] = useState(false)

  const isVisible = phase.visible_to_tenant

  async function handleToggle() {
    const nextVisible = !isVisible

    setLoading(true)

    try {
      await togglePipelinePhaseVisibilityToTenant(phase.id)
      await onReloadPhase(phase.id)

      handleReloadOpenActivities?.()
      handleAddSuccessNotification(
        getActivityVisibilityChangeNotificationKey(nextVisible)
      )
    } catch {
      handleAddErrorNotification(
        getActivityVisibilityChangeNotificationKey(nextVisible, {
          isError: true,
        })
      )
    } finally {
      setLoading(false)
    }
  }

  const icon = (
    <IconNG
      Icon={getVisibilityIcon(isVisible)}
      color={ICON_COLOR.CurrentColor}
      size={ICON_HEIGHT_16}
    />
  )

  return canEdit ? (
    <RequestProfileTabActivitiesPhaseHeaderMetaItem
      interactive
      isLoading={isLoading}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_VISIBILITY}
      tooltipKey={
        isVisible
          ? 'RequestProfileTabActivities.HideForDwellersActionKey'
          : 'RequestProfileTabActivities.ShowForDwellersActionKey'
      }
      onClick={handleToggle}
    >
      {icon}
    </RequestProfileTabActivitiesPhaseHeaderMetaItem>
  ) : (
    icon
  )
}

export default RequestProfileTabActivitiesPhaseHeaderVisibility
